module.exports = __webpack_public_path__ + "static/portfolio-d6f04483222380f6179a2ae1fbad50c9.png";